<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Usuário" subTitle="Adicionar" />

    <!-- Content -->
    <user-account-details/>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import UserAccountDetails from '_modules/user/components/UserAccountDetails.vue';

export default {
  name: 'user-create',
  components: {
    PageHeader,
    UserAccountDetails,
  },
  computed: {
  },
  data() {
    return {};
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
};
</script>

